import {FC} from 'react'
import s from './style.module.css'

interface Props {
  text: string
}

const TagContent: FC<Props> = ({text}) => {
  return <div className={s.tag}>{text}</div>
}

export default TagContent
